import React, { useState, useEffect, useCallback } from 'react'
import './../buttons/styles.scss'
import './styles.scss'
import { useDropzone } from 'react-dropzone'
import arrow from './../../images/upload-ico.svg'
import loading from './../../images/loading-ico.svg'
import info from './../../images/i-ico-blue.svg'
import ModalMessage from '../modal-message/ModalMessage';


const UploadDragDropFiles = ( props ) => {
    let [ uploadedFile, setUploadedFile ] = useState( false );
    let [ loadedApi, setLoadedApi ] = useState(false);
    let [ error, setError ] = useState(false);
    let [ activeModal, setActiveModal ] = useState(false);
    let [ uploadedFileText, setUploadedFileText ] = useState( 'Przeciągnij plik / <br /> Wczytaj z dysku' );


    useEffect(() => {
      setError( props.error );
    }, [props.error]);

    useEffect(() => {
      setUploadedFileText( props.buttonText );
    }, [props.buttonText]);
    
    let onDrop = useCallback((acceptedFiles ) => {
    
        const reader = new FileReader()
        reader.onabort = () => setUploadedFileText('Plik odrzucono')
        reader.onerror = () => setUploadedFileText('Błąd w trakcie wczytywania pliku')
        reader.onprogress = () => setUploadedFileText('Wczytuję plik')
        reader.onload = () => {
          setUploadedFile( true );
          setUploadedFileText(`Plik został wgrany poprawnie`);
        }
        let tempArray = [];
        acceptedFiles.forEach( async file => {
            tempArray = [...tempArray, file]
        })
        props.setFunction(tempArray);
      }, [])

    let {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})


    return (
        <>
        { props.update >= 0 && 
          <div className="upload-wrapper">
            <div className="btn-wrap">
                <div className={"btn white upload " +  ( props.tip ? 'have-tip ' : '') + ( loadedApi ? 'loading' : '' ) + " " + ( error ? 'error' : '')} {...getRootProps()}>
                    <input {...getInputProps()} />
                    <span dangerouslySetInnerHTML={ {__html: uploadedFileText} } />
                    <img className="upload-ico" src={ (loadedApi ? loading : arrow) } alt="Upload"/>
                </div>
                { props.tip && 
                    <img src={ info } className="tip" alt="informacja" onClick={ () => setActiveModal( true )} />
                }
            </div>
            
            { activeModal &&
                <ModalMessage   closeModal={ () => setActiveModal(false) } 
                                button={ props.button } 
                                buttonClass="blue" 
                                buttonTitle={ props.buttonTitle }
                                buttonArrow={ true } 
                                tipHeader={ props.tipHeader }
                                tipText={ props.tipText } />
            }
          </div>
        }
        
        </>
    )
}

export default UploadDragDropFiles;